// currency: moneda en la que se cobra y se guarda el pago (USD -> amountUsd, BS -> amountBs)
export const PAYMENT_METHODS = [
  { value: 'EFECTIVO_USD', label: 'Efectivo $', icon: 'bi-cash-stack', currency: 'USD' },
  { value: 'ZELLE', label: 'Zelle', icon: 'bi-globe', currency: 'USD' },
  { value: 'EFECTIVO_BS', label: 'Efectivo Bs', icon: 'bi-cash', currency: 'BS' },
  { value: 'PUNTO', label: 'Punto de venta', icon: 'bi-credit-card', currency: 'BS' },
  { value: 'PAGO_MOVIL', label: 'Pago móvil', icon: 'bi-phone', currency: 'BS' },
  { value: 'TRANSFERENCIA', label: 'Transferencia', icon: 'bi-bank', currency: 'BS' },
];

// Diferencia máxima aceptada (en $) por redondeo de la conversión; igual que en el backend
export const PAYMENT_TOLERANCE_USD = 0.01;

function find(value) {
  return PAYMENT_METHODS.find(m => m.value === value);
}

export function paymentMethodLabel(value) {
  return find(value)?.label || value;
}

export function paymentMethodIcon(value) {
  return find(value)?.icon || 'bi-wallet2';
}

export function paymentMethodCurrency(value) {
  return find(value)?.currency || 'USD';
}
